<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NPwC5R/tc-custom/9781612434735.jpg?1704761296560" alt="This image is the cover for the book Liver Healing Diet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Liver Healing Diet
      </h1>
      <p class="bookDescription body article font2">
        <b>The first book to provide you with a detailed program for reversing liver damage through optimal nutrition—from two of the country’s top liver specialists.</b><br/><br/>The only organ in your body that regenerates itself is the liver. And now, you can make it happen. With a complete program to rejuvenate your liver through optimal nutrition and routine exercise, <i>The Liver Healing Diet</i> shows you how to:Improve liver functionBeat fatty liver diseaseDetoxify the liverBoost all-around healthNourish the body with delicious recipes<br/><br/><i>The Liver Healing Diet</i> teaches you basic liver facts, how to talk to your doctor about liver disease and what steps you need to reverse years of abuse. With your newly repaired liver you’ll feel better, have more energy and live a healthy lifestyle.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Lai, Asha Kasaraneni
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b371f30